import makeStyles from "@mui/styles/makeStyles";
import { theme } from "../../../App";

const useStyles = makeStyles(() => ({
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  answer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      flexWrap: "nowrap",
    },
  },
  flexColumn: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  numberSlider: {
    flexGrow: 1,
    margin: "0 32px",
    paddingTop: 10,
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      marginBottom: 10,
    },
  },
  numberInput: {
    maxWidth: "max-content",
  },
  clearButtonContainer: {
    maxWidth: "min-content",
    margin: (props) => {
      if (props.interactionType === "stepper") return "10px 0 0 0";
    },
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginTop: 10,
    },
  },
  clearButton: {
    fontSize: 12,
    background: "none !important",
    border: "none",
    color: (props) => props.currentTheme.primaryColor,
    cursor: "pointer",
    textAlign: "center",
    "&:hover": {
      color: "#004f9a",
    },
    "&:focus": {
      outline: "none",
    },
  },
  errorText: {
    color: "red",
    paddingTop: 8,
    fontSize: 14,
    flexBasis: "100%",
  },
  sliderErrorText: {
    paddingTop: 16,
    [theme.breakpoints.down("sm")]: {
      paddingTop: 8,
    },
  },
}));

export default useStyles;
